<template>
  <div class="feedBack-manage-bd tb">
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
    ></custom-tab>
    <div class="tab-content">
      <!-- 未完成 -->
      <undone v-if="tabIndex !== 100" :flowNodeNo="tabIndex" :isHq="isHq"></undone>
      <!-- 已完成 -->
      <done v-if="tabIndex === 100" :isHq="isHq"></done>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import undone from './children/undone';
import done from './children/done';

export default {
  components: { undone, done },
  name: 'feedBackManage',
  computed: {
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    },
    isHq() {
      return this.bizType === 'HQ';
    },
    tabData() {
      let arr = [];
      if (this.bizType === 'HQ') {
        const authList = this.authList.map((i) => {
          const obj = {};
          obj.name = i.flowNodeName;
          obj.value = i.flowNodeNo;
          return obj;
        });
        authList.push({
          name: this.$t('asm_feedBackManage.yi_wan_cheng'),
          value: 100,
        },);
        arr = authList;
      } else if (this.bizType === 'SC' || this.bizType === 'JV_SC') {
        arr = [
          {
            name: this.$t('asm_feedBackManage.dai_ti_jiao'),
            value: 0,
          },
          {
            name: this.$t('asm_feedBackManage.wei_wan_cheng'),
            value: 1,
          },
          {
            name: this.$t('asm_feedBackManage.yi_wan_cheng'),
            value: 100,
          }
        ];
      }
      return arr;
    }
  },
  watch: {
    bizType: {
      handler(newVal) {
        if (newVal === 'HQ') {
          this.getApproveAuth();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      formSearch: {
        productCode: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tabIndex: 0,
      authList: [],
      // tabData: [
      //   {
      //     name: '未完成',
      //     value: 0,
      //   },
      //   {
      //     name: '已完成',
      //     value: 1,
      //   },
      // ],

      tableList: [],
      totalRows: null,
    };
  },
  mounted: function () {
  },
  methods: {
    getApproveAuth() {
      this.$getJSON(`${apis.apsApproveGetApproveAuthFlowNode}/feed_back`).then((res) => {
        this.authList = res.data;
        this.tabIndex = res.data[0].flowNodeNo;
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.feedBack-manage-bd {
  padding: 0 !important;
  display: flex;
  flex-direction: column;

  .tab-content {
    flex: 1;
  }
}
</style>
